import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { checkIsArchiveSellSide } from '../../../utils';
import ArchiveDetails from '../ArchiveDetails';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { DataRoomArchive, DataRoomArchiveInstance } from '../../../types';
import {
  DATE_FORMAT_COMPACT_WITH_FULL_YEAR_SLASH,
  getFormattedDate,
} from 'dateUtils';

import './ArchiveInstance.styles.scss';

export type ArchiveInstanceProps = {
  className?: string;
  archiveInstance: DataRoomArchiveInstance;
  updateArchive: (archive: DataRoomArchive) => void;
};

const ArchiveInstance: React.FC<ArchiveInstanceProps> = (props) => {
  const { className, archiveInstance, updateArchive } = props;

  const { createdAt, shareIndex, dataRoomBuySideGroup, type } =
    archiveInstance || {};

  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  const classes = classNames('archive-instance', className);

  const { t } = useTranslation();

  const isSellSide = useMemo(() => checkIsArchiveSellSide(type), [type]);

  return (
    <div className={classes}>
      <p>
        {getFormattedDate(createdAt, DATE_FORMAT_COMPACT_WITH_FULL_YEAR_SLASH)}
      </p>

      <span>
        {t(
          isSellSide
            ? 'fullDataRoomIndexGenerated'
            : shareIndex
            ? 'indexGeneratedAndShared'
            : 'indexGenerated',
          {
            name: dataRoomBuySideGroup?.name,
          },
        )}{' '}
        <Button variant="link" onClick={modal?.open}>
          {t('details')}
        </Button>
      </span>

      <ArchiveDetails
        ref={modalRef}
        archiveInstance={archiveInstance}
        updateArchive={updateArchive}
      />
    </div>
  );
};

export default ArchiveInstance;
